import { apiRequest } from '../../apiCall'

export const getInstruction = (params) => apiRequest('Instruction.GetInstruction', {}, `?CustomerLineId=${params}`);
export const setUserOnline = () => apiRequest('Operator.SetOperatorOnline', {}, '', true);
export const setUserOffline = () => apiRequest('Operator.SetOperatorOffline', {}, '', true);

